import React from "react";

const SvgSkyMinderAirating = props => (
  <svg viewBox="0 0 200 200" {...props}>
    <g data-name="Horn\xED menu + Footer">
      <g data-name="SkyMinder a irating">
        <path d="M154.65 159.37H43.38a5.24 5.24 0 01-5.28-5.19V47.82a5.24 5.24 0 015.28-5.19h56a3.2 3.2 0 010 6.39H44.49V153h109.06v-52.08a3.2 3.2 0 016.39 0v53.26a5.25 5.25 0 01-5.29 5.19z" />
        <path d="M116.33 42.18a5.32 5.32 0 003.67 9.11l23.68.14L97.55 97.6a5.34 5.34 0 107.55 7.55l46.08-46.08-.18 23.61a5.33 5.33 0 0010.66.07l.22-36.5a5.49 5.49 0 00-1.52-3.8.46.46 0 00-.07-.07 5.29 5.29 0 00-3.7-1.52h-.18l-36.32-.23a5.32 5.32 0 00-3.76 1.55z" />
      </g>
    </g>
  </svg>
);

export default SvgSkyMinderAirating;

